<template>
  <div
    class="center"
    :class="{ 'desktop-listing': !isMobile, 'mobile-listing': isMobile }"
  >
    <v-container fluid grid-list-md>
      <!--<v-card flat>-->
      <!--<v-card-title primary-title>-->
      <!--<div class="center">-->
      <!--<span class="headline mb-0 pl-2">Listings</span>-->
      <!--</div>-->
      <!--</v-card-title>-->
      <!--<div style="padding-bottom:25px;"></div>-->
      <!--</v-card>-->
      <v-data-iterator
        :items="properties"
        :items-per-page.sync="itemsPerPage"
        hide-default-footer
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="(item, index) in props.items"
              :key="item.id"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <div class="center listing-card">
                <v-hover>
                  <v-card
                    flat
                    slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                    @click="detail(index)"
                  >
                    <div class="img-container">
                      <!-- The v-in-view directive will trigger the 'imgInView' method -->
                      <div
                        class="img-border"
                        v-in-view="imgInView"
                        :data-index="index"
                        :id="'img' + index"
                        @click="detail(index)"
                      >
                        <v-img
                          :lazy-src="getLazyLoadThumb(item)"
                          :src="getPic(item)"
                          width="436"
                          height="290"
                        >
                          <v-layout
                            slot="placeholder"
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular
                              indeterminate
                              color="red"
                            ></v-progress-circular>
                          </v-layout>
                        </v-img>
                        <span v-if="item.sold" class="listing-status sold"
                          >Sold</span
                        >
                        <span
                          v-else-if="item.leased"
                          class="listing-status sold"
                          >Leased</span
                        >
                        <span v-else class="listing-status active">Active</span>
                      </div>
                    </div>
                    <v-card-title
                      ><h4>{{ item.title }}</h4></v-card-title
                    >
                    <v-card-title v-if="item.soldDate"
                      ><span class="label">Sold date：</span
                      ><span class="value">{{
                        item.soldDate
                      }}</span></v-card-title
                    >
                    <v-card-title v-if="item.sold">
                      <span class="label">Sold Price:</span
                      ><span class="value">{{
                        formatPrice(item.soldPrice)
                      }}</span>
                      <span
                        v-if="
                          item.soldPrice &&
                          item.price &&
                          item.soldPrice > item.price
                        "
                        class="value"
                        style="font-weight: bold; font-style: italic"
                        >&nbsp;&nbsp;sold price
                        {{ formatPrice(item.soldPrice - item.price) }} over
                        asking price</span
                      >
                    </v-card-title>
                    <v-card-title v-else-if="!item.leased"
                      ><span class="label">Listing Price:</span
                      ><span class="value">{{ formatPrice(item.price) }}</span>
                      <v-btn small text @click="calculate(item.price)"
                        ><v-icon size="12" color="grey darken-1"
                          >fas fa-calculator</v-icon
                        >&nbsp;<span class="link"
                          >Mortgage Calculator</span
                        ></v-btn
                      >
                    </v-card-title>
                    <v-card-title
                      ><span class="label">Living Area:</span
                      ><span class="value">{{ item.livingArea }} Sq. Ft.</span>
                    </v-card-title>
                    <v-card-title
                      ><span class="label">Lot Size:</span
                      ><span class="value">{{
                        item.lotSize
                          ? item.lotSize + " Sq. Ft."
                          : item.lotSizeAcre
                          ? item.lotSizeAcre + " Acres"
                          : ""
                      }}</span>
                    </v-card-title>
                    <v-card-title
                      ><span class="label">Bedrooms:</span
                      ><span class="value">{{ item.bedroom }}</span>
                    </v-card-title>
                    <v-card-title
                      ><span class="label">Bathrooms:</span
                      ><span class="value">{{ item.bathroom }}</span>
                    </v-card-title>
                    <v-card-title
                      ><span class="label">Year Build:</span
                      ><span class="value">{{
                        item.yearBuild
                      }}</span></v-card-title
                    >
                    <div class="center" style="padding-bottom: 15px">
                      <v-btn small rounded @click="detail(index)">
                        Detail&nbsp;<v-icon small color="pink"
                          >fas fa-chevron-right</v-icon
                        >
                      </v-btn>
                    </div>
                  </v-card>
                </v-hover>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <div class="pb-5"></div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { Utils } from "../utils";
import "../in-view"; // Import the directive

export default {
  name: "listing",
  data() {
    return {
      imgPath: "http://www.juliazhao.com/realestate/properties/",
      itemsPerPage: 6, // Start by showing 6 items
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.homeStore.isMobile,
      calculator: (state) => state.homeStore.calculatePrice,
      properties: (state) => state.listingStore.properties,
      // soldProperties: state => state.soldPropertyStore.properties
    }),
  },
  methods: {
    ...mapMutations(["setCurrentProperty", "setCalculatePrice"]),
    formatPrice: function (price) {
      return Utils.getPriceTxt(price, false);
    },
    detail(index) {
      this.setCurrentProperty(this.properties[index]);
      this.$router.push("/detail");
    },
    imgInView(entry) {
      // console.log("In view:", entry); // Use console.log for debugging if needed
      const index = parseInt(entry.target.dataset.index, 10);
      // Once an item is in view, make the next few visible so they can be observed
      if (entry.isIntersecting && index + 1 >= this.itemsPerPage) {
        this.itemsPerPage += 6; // Load next 6
      }
    },
    calculate(price) {
      this.setCalculatePrice(price);
      this.$router.push("/calculator");
    },
    getPic(item) {
      if (item.thumb) return this.imgPath + item.id + "/" + "thumb.jpg";
      return this.imgPath + item.id + "/" + item.pics[0];
    },
    getLazyLoadThumb(item) {
      if (!item.thumb) return "";
      if (item.picsWithTitle)
        return this.imgPath + item.id + "/thumbs/" + item.picsWithTitle[0].pic;
      return this.imgPath + item.id + "/thumbs/" + item.pics[0];
    },
  },
};
</script>

<style scoped>
@import "listing.css";
</style>
